import { Grid, InputAdornment } from "@mui/material";
import { NumberFormatInput } from "components/FormControls/NumberFormatInput";
import { RequiredFieldLabel } from "components/FormControls/RequiredFieldLabel";
import { useMessage } from "hooks/intl";
import {
  AchievementCompleteRulePeriod,
  CompleteRule,
} from "types/achievements";
import { pluralizeValueAdornment } from "utilities/strings";
import { getValueAdornment } from "../utils";

export const lastXDaysInitalValues = {
  period: { type: AchievementCompleteRulePeriod.LAST_DAY, value: "" },
  periodGoal: "",
  onlyUniqueAttributeValues: undefined,
};

interface Props {
  activeRule: number;
  completeRule?: CompleteRule & {
    draft?: CompleteRule;
    isEditing?: boolean;
  };
  errors: any;
  fieldName: string;
}

export const LastXDays = ({
  activeRule,
  completeRule,
  errors,
  fieldName,
}: Props) => {
  const { message } = useMessage();

  return (
    <>
      <Grid item xs={6}>
        <NumberFormatInput
          allowDecimals
          data-test-id={`rule-${activeRule}-goal-input`}
          label={
            <RequiredFieldLabel
              text={message({
                id: "goal",
              })}
            />
          }
          name={`${fieldName}.periodGoal`}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                {message({
                  id: getValueAdornment(completeRule?.period?.type),
                }).toLowerCase()}
              </InputAdornment>
            ),
          }}
          error={errors?.completeRule?.periodGoal}
        />
      </Grid>
      <Grid item xs={6}>
        <NumberFormatInput
          data-test-id={`rule-${activeRule}-goal-value-input`}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                {message({
                  id: pluralizeValueAdornment(
                    "day",
                    completeRule?.period?.value,
                  ),
                }).toLowerCase()}
              </InputAdornment>
            ),
          }}
          label={
            <RequiredFieldLabel
              text={message({
                id: "over",
              })}
            />
          }
          name={`${fieldName}.period.value`}
          error={errors?.completeRule?.period?.value}
        />
      </Grid>
    </>
  );
};
